import React, { useRef, useEffect, useState } from 'react';
import InvoiceSettingsConfigurationsController from '../../../../Controllers/AdminScreens/Invoices/Settings/InvoiceSettingsConfigurationsController';
import Dropdown from '../../../../../Components/Dropdown';
import DateInput from '../../../../../Components/DateInput';
import Input from '../../../../../Components/Input';
import Loader from '../../../../../Components/Loader';

const InvoiceSettingsConfigurationsScreen = ({ showServiceEstimateSeries, editServiceEstimateSeries, selectedServiceEstimate, toggleServiceEstimateSeries, showInvoiceSeries, editInvoiceSeries, selectedInvoiceSeries, toggleInvoiceSeries, showReceiptSeries, editReceiptSeries, selectedReceiptSeries, toggleReceiptSeries, onRefresh }) => {
    const {
        seriesType,
        setSeriesType,
        seriesPrefix,
        setSeriesPrefix,
        startDates,
        setStartDates,
        endDates,
        setEndDates,
        error,
        successMessage,
        addLoading,
        handleInvoice,
        seriesTypeError,
        seriesPrefixError,
        startDatesError,
        endDatesError,
        clearFeilds,
    } = InvoiceSettingsConfigurationsController(showServiceEstimateSeries, editServiceEstimateSeries, selectedServiceEstimate, showInvoiceSeries, editInvoiceSeries, selectedInvoiceSeries, showReceiptSeries, editReceiptSeries, selectedReceiptSeries, onRefresh);
    console.log("start date", startDates, endDates)

    const dropdownRefs = useRef({});
    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown

    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getLabelText = () => {
        if (editServiceEstimateSeries) return "Edit Service Estimate Series";
        if (editInvoiceSeries) return "Edit Invoice Series";
        if (editReceiptSeries) return "Edit Receipt Series";
        if (showServiceEstimateSeries) return "Service Estimate Series";
        if (showInvoiceSeries) return "Invoice Series";
        if (showReceiptSeries) return "Receipt Series";
        return "";
    }

    const getActionType = () => {
        if (showServiceEstimateSeries) return "ESTIMATE_SERIES_ADD";
        if (showInvoiceSeries) return "INVOICE_SERIES_ADD";
        if (showReceiptSeries) return "RECEIPT_SERIES_ADD";
        if (editServiceEstimateSeries) return "ESTIMATE_SERIES_UPDATE";
        if (editInvoiceSeries) return "INVOICE_SERIES_UPDATE";
        if (editReceiptSeries) return "RECEIPT_SERIES_UPDATE";
        return null;
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>Configuration</h2>
            {(showServiceEstimateSeries || showInvoiceSeries || showReceiptSeries || editServiceEstimateSeries || editInvoiceSeries || editReceiptSeries) && (
                <>
                    <div style={styles.form}>
                        <div style={styles.row}>
                            <label style={styles.label}>{getLabelText()}</label>
                            <Dropdown
                                ref={(el) => (dropdownRefs.current["SeriesDropdown"] = el)}
                                isOpen={openDropdown === "SeriesDropdown"}
                                toggleDropdown={() => toggleDropdown("SeriesDropdown")}
                                value={seriesType}
                                onChange={(selectedOption) => setSeriesType(selectedOption?.value)}
                                options={[
                                    { "label": "Automatic", "value": 2 },
                                    { "label": "Manual", "value": 1 },
                                    { "label": "Prefix", "value": 3 },
                                ]}
                                searchBoxWidth={150}
                                errorMessage={seriesTypeError}
                            />
                            {seriesType === 3 ? (
                                <Input
                                    type="text"
                                    placeholder="Enter"
                                    value={seriesPrefix}
                                    onChange={(e) => setSeriesPrefix(e.target.value)}
                                    style={styles.input}
                                    searchBoxWidth={150}
                                    errorMessage={seriesPrefixError}
                                />
                            ) : null}
                            <DateInput
                                placeholder="Start Date"
                                value={startDates || ""}
                                onChange={(e) =>
                                    setStartDates(e.target.value)
                                }
                                errorMessage={startDatesError}
                                min={new Date().toLocaleDateString("en-CA")}
                            />
                            <DateInput
                                placeholder="End Date"
                                value={endDates || ""}
                                onChange={(e) =>
                                    setEndDates(e.target.value)
                                }
                                errorMessage={endDatesError}
                                min={new Date().toLocaleDateString("en-CA")}
                            />
                        </div>


                    </div>

                    <hr className="footer-divider" />

                    {/* Buttons */}
                    <div className="button-container" style={{ gap: "10px" }}>
                        <button className="add-client-button" style={{
                            paddingLeft: '30px',
                            paddingRight: '30px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px', // Add spacing between text and loader
                            position: 'relative',
                            opacity: addLoading ? 0.5 : 1, // Reduce opacity when loading
                            cursor: addLoading ? 'not-allowed' : 'pointer',
                        }}
                            onClick={() => {
                                const action = getActionType();
                                if (action) handleInvoice(action);
                            }} disabled={addLoading}>
                            {editServiceEstimateSeries || editInvoiceSeries || editReceiptSeries ? "Update" : "Add"}
                            {addLoading && (
                                <Loader loading={addLoading} color={'var(--background-color)'} size="small" />
                            )}</button>
                        <button style={styles.cancelButton} onClick={() => {
                            if (showServiceEstimateSeries || showInvoiceSeries || showReceiptSeries) {
                                clearFeilds();
                            } else {
                                if (editServiceEstimateSeries) toggleServiceEstimateSeries();
                                if (editInvoiceSeries) toggleInvoiceSeries();
                                if (editReceiptSeries) toggleReceiptSeries();
                            }
                        }}>Cancel</button>
                        {error && <div className="list-error-msg" style={{ marginBottom: '3px' }}> {error} </div>}
                        {successMessage && <div className="list-success-msg" style={{ marginBottom: '3px' }}>{successMessage} </div>}
                    </div>
                </>
            )}
        </div>
    );
};

const styles = {
    // container: {
    //   width: "600px",
    //   margin: "0 auto",
    //   fontFamily: "Arial, sans-serif",
    // },
    title: {
        color: 'black',
        fontSize: 18,
        fontFamily: 'Roboto',
        fontWeight: '500',
        marginBottom: '10px'
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: "15px",
    },
    row: {
        display: "grid",
        gridTemplateColumns: "200px 175px 175px 175px 175px",
        gap: "10px",
        alignItems: "center",
    },
    dateRow: {
        display: "flex",
        alignItems: "center",
        gap: "10px"
    },
    label: {
        width: "200px",
        fontSize: 14,
        fontWeight: "400",
    },
    input: {
        flex: 1,
        padding: "8px",
        border: "1px solid #d1d5db",
        borderRadius: "4px",
        fontSize: "14px",
    },
    updateButton: {
        backgroundColor: "#40513B",
        color: "white",
        border: "none",
        padding: "8px 16px",
        borderRadius: '20px',
        cursor: "pointer",
    },
    cancelButton: {
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px solid var(--button-bg-color)",
        padding: "8px 16px",
        borderRadius: '20px',
        cursor: "pointer",
    },
    spacer: {
        width: "140px",
    },
};

export default InvoiceSettingsConfigurationsScreen;
